import { gql } from 'apollo-angular';

const ADD_CATEGORY = gql`
  mutation AddCategory($id: Long!, $categoryId: Long!) {
    addCategory(addCategoryRequest: { id: $id, categoryId: $categoryId }) {
      id
    }
  }
`;

export default ADD_CATEGORY;
